import styled, { css } from 'styled-components';
import {
  margin,
  MarginProps,
  display,
  DisplayProps,
  PaddingProps,
  padding,
} from 'styled-system';

export const SubscriptionItem = styled.div<MarginProps>`
  ${margin};
`;

export const ToggleWrapper = styled.div<MarginProps & DisplayProps>`
  cursor: pointer;
  ${display};
  ${margin};
`;

export const FooterContentWrapper = styled.div`
  text-align: center;
`;

export const RowWrapper = styled.div<MarginProps & PaddingProps>`
  ${margin};
  ${padding};
  ${({ theme }) =>
    theme &&
    css`
      border-top: 1px solid ${theme.colors.gray.light};
    `};
`;
